import React, { useState } from "react";
import { Activity } from "@ofqual/portal-activity-feed";
import { ActivityFeed } from "@ofqual/portal-activity-feed";
import { EntityDialog, DialogType } from "./types";
import { RenderDialog } from "./RenderDialog";
import { InformationRequest, InformationRequestStatus } from "../../../domain/InformationRequest";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { requestTypeLookupService } from "../../../services";
import { FilterCheckbox } from "@ofqual/portal-components/components/ResponseFilter";
import { QueryParams } from "@ofqual/portal-core/core/types";
import { ActivityType, allActivityTypes } from "../../../domain/ActivityType";
import { buildDefinitions } from "./buildDefinitions";

type CaoActivityFeedProps = {
  resourceId: string;
  informationRequest: InformationRequest;
  itemId?: string;
  disabled?: boolean;
};

export const CaoActivityFeed: React.FC<CaoActivityFeedProps> = ({
  resourceId,
  informationRequest,
  itemId,
  disabled,
}) => {
  const [focussedEntity, setFocussedEntity] = useState<EntityDialog | null>(
    null
  );

  const [requestTypeLookups] = useLookup(requestTypeLookupService);

  const showMessage: boolean = InformationRequestStatus.Draft === informationRequest.status
    ? true
  : disabled ? disabled : false;

  console.log ("CAO STATUS", showMessage)
  const definitions = buildDefinitions(
    (activity: Activity) => {
      setFocussedEntity({
        dialogType: DialogType.ActivityAction,
        focussedActivity: activity,
      });
    },
    informationRequest,
    requestTypeLookups
  );

  const menuActions = itemId
    ? [
        {
          label: "Send Message",
          dataTest: "send-message",
          action: () =>
            setFocussedEntity({
              dialogType: DialogType.SendMessage,
            }),
          disabled : showMessage
        },
      ]
    : [];

  // default the filter to being active so we exclude changes
  const [excludeChecked, setExcludeChecked] = useState(true);
  const [filterCount, setFilterCount] = useState(1);

  const defaultExcludeActivityTypes = {
    activityTypes: [
      ActivityType.InformationRequestRecipientMessage,
      ActivityType.InformationRequestMessageSent,
      ActivityType.InformationRequestRespondToMessageAction,
      ActivityType.InformationRequestUploadDocumentsAction,
      ActivityType.InformationRequestReadDocumentsAction,
      ActivityType.InformationRequestRecipientMessageAO,
      ActivityType.InformationRequestMessageSentAO,
    ],
  };

  const [params, setParams] = useState<QueryParams | undefined>(
    defaultExcludeActivityTypes
  );

  return (
    <>
      <ActivityFeed
        resourceId={resourceId}
        definitions={definitions}
        params={params}
        actions={menuActions}
        activeFilters={filterCount}
      >
        {(workingParams, dirtyParams, addParam) => (
          <>
            <FilterCheckbox
              dataTest="exclude-updates-checkbox"
              isChecked={excludeChecked}
              name="activityTypes"
              text="Exclude updates"
              onChange={(e) => {
                let newActivityTypes = allActivityTypes;
                if (e && e.target.checked) {
                  newActivityTypes = defaultExcludeActivityTypes.activityTypes;
                  setFilterCount(filterCount + 1);
                } else {
                  newActivityTypes = allActivityTypes;
                  setFilterCount(filterCount - 1);
                }
                setParams({ activityTypes: newActivityTypes });
                addParam("activityTypes", newActivityTypes);
                if (e) setExcludeChecked(e.target.checked);
              }}
            />
          </>
        )}
      </ActivityFeed>

      <RenderDialog
        focussedEntity={focussedEntity}
        onClose={() => setFocussedEntity(null)}
        informationRequest={informationRequest}
        resourceId={resourceId}
      />
    </>
  );
};
